import helper, { getSlugByLang, getSlugNameByLang } from "../common/Helper";
import noTour from "../assest/myImages/no-tour-img.png";
import Attraction from "./Skeletons/Attraction";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const BlogCatListCard = ({
    blogList,
    isLoading
}) => {

    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)

    const options = {
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1.08
            },
            600: {
                items: 1.08
            }
        }
    };

    return (
        <section className="pageSection2">
            <div className="Section2Box">
                <div className="container">
                    <div className="sectionTitle">
                        <h3>{blogList?.length > 0 && "Explore Blog Categories"}</h3>
                    </div>
                    <div className="placeSecDesktop">
                        <div className="placeSec">
                            <div className="row">

                                {
                                    isLoading ?
                                        <>
                                            <Attraction records={9} />
                                        </> :
                                        blogList?.length > 0 ?
                                            blogList.map((val, ind) => {


                                                return (
                                                    <div className="col-lg-4 col-md-6" key={ind}>
                                                        <Link to={(slugLang ? ('/' + slugLang) : '') + '/blog/category/' + val.slug} style={{ width: "100%", height: "100%" }}>
                                                            <div className="travelBox">
                                                                <div className="imgBox">
                                                                    <img loading="lazy"
                                                                        src={helper.S3Url + '/' + helper.blogImageDir + '/' + val.listing_image}

                                                                        alt={val?.name}
                                                                        onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.src = noTour
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="textBox">
                                                                    {/* <p className="oneLine">
                                                                        {moment(val?.created_at).format('DD MMM YYYY')}</p> */}
                                                                    <h6
                                                                        style={{ height: "unset" }}
                                                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                                                        data-bs-custom-class="custom-tooltip"
                                                                        data-bs-title="This top tooltip is themed via CSS variables."
                                                                        title={val.name}>{val.name}</h6>
                                                                    <p className="cat-blog-short-desc">{(val.short_description)}</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            }) :
                                            <h4>No Blog Categories Found</h4>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="placeSecMobile">
                        {
                            isLoading ?
                                <>
                                    <Attraction records={1} />
                                </> :
                                <OwlCarousel className='owl-theme' key={blogList.length} id="mobileSlider-1" {...options}>
                                    {
                                        blogList?.length > 0 &&
                                        blogList.map((val, ind) => {


                                            return (
                                                <div className="col-lg-4 col-md-6" key={ind}>
                                                    <Link to={(slugLang ? ('/' + slugLang) : '') + '/blog/category/' + val.slug} style={{ width: "100%", height: "100%" }}>
                                                        <div className="travelBox">
                                                            <div className="imgBox">
                                                                <img loading="lazy"
                                                                    src={helper.S3Url + '/' + helper.blogImageDir + '/' + val.listing_image}

                                                                    alt={val?.name}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = noTour
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="textBox">
                                                                {/* <p className="oneLine">
                                                                        {moment(val?.created_at).format('DD MMM YYYY')}</p> */}
                                                                <h6
                                                                    style={{ height: "unset" }}
                                                                    data-bs-toggle="tooltip" data-bs-placement="top"
                                                                    data-bs-custom-class="custom-tooltip"
                                                                    data-bs-title="This top tooltip is themed via CSS variables."
                                                                    title={val.name}>{val.name}</h6>
                                                                <p className="cat-blog-short-desc">{(val.short_description)}</p>

                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            )
                                        })
                                    }
                                </OwlCarousel>
                        }
                    </div>
                </div>
            </div>
        </section>
    )

}
export default BlogCatListCard